export enum InstellingBron {
	Somtoday = 'Somtoday',
	Magister = 'Magister',
}
